import axiosInstance from '../utils/axiosInstance.js';
import { route_tenant_config } from "../constants/BackendRoutes.js"

export async function loadTenantConfig(
  tenantName,
  deviceType
) {
  try {

    // Fetch the tenant specific display config 
    const url = `${route_tenant_config}/${tenantName}/${deviceType}`;
    console.log("Loading config:", url);
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (err) {
    console.error(
      "Failed to load tenant config",
      err
    );
  }
  return null;
}